<field-select {(field)}="channel" options="channelOption"></field-select>
<field-select {(field)}="message" options="messageOption"></field-select>
{{#is message customOption}}<field-text {(field)}="customMessage" max-length="{{messageMaxLength}}"></field-text>{{/is}}
